// extracted by mini-css-extract-plugin
export var cancelButton = "_oo-5";
export var content = "_oo-3";
export var createButton = "_oo-6";
export var drawerContainer = "_oo-0";
export var footer = "_oo-2";
export var header = "_oo-1";
export var orderFormColumn = "_oo-4";